import { useState } from "react";

import InputNumberUI from "@UI/InputNumberUI";
import InputUI from "@UI/InputUI";
import SelectSuggestUI from "@UI/SelectSuggestUI";
import { inject, observer } from "mobx-react";

import { Calendar } from "primereact/calendar";
import moment from "moment";
import ButtonUI from "@UI/ButtonUI";

import "./style.scss";

const AddContract = inject("mainStore")(
    observer(({ mainStore, item, getContract, select }) => {
        const detailData = mainStore.getMainStore("detailData");
        const [data, setData] = useState(item);

        const disableBlock = detailData.vendorInfo?.ozonId ? true : false;
        const isDisable = item._id;

        const handleGetContract = async () => {
            let obj = { ...data, contractDate: moment(data.contractDate).format("YYYY-MM-DD"), expirationDate: "", vendorId: detailData._id, contractType: "CONTRACT_TYPE_SERVICE" };

            if (item._id) {
                const response = await mainStore.getByUrl(`promo/createContractInOzon/${item._id}`, false, false, false);
                if (response && response.success) {
                    mainStore.setMainStore("toast", { severity: "success", life: 4000, summary: "Договор отправлено в ORD. Вы можете опубликовать вендор " });
                }
            } else {
                const resp = await mainStore.postByUrl("promo/contracts", obj, false, false, false);
                if (resp && resp.success) {
                    getContract();
                    const response = await mainStore.getByUrl(`promo/createContractInOzon/${resp.data._id}`, false, false, false);
                    if (response && response.success) {
                        mainStore.setMainStore("toast", { severity: "success", life: 4000, summary: "Договор отправлено в ORD. Вы можете опубликовать вендор " });
                    }
                }
            }
        };

        const disableButton = !data.contractNumber || !data.contractDate;

        return (
            <div className={`step__block ${disableBlock ? "" : "disable"}`}>
                <span className="title">Шаг 2. Добавление договора</span>
                <div className="block">
                    <div className="link">
                        <i className="pi pi-info-circle" />
                        <a style={{ pointerEvents: disableBlock ? "all" : "none" }} href="https://drive.google.com/drive/folders/1jjTrOXB99uHAHadFI6oHJIiyogJHN68V" target="_blank" rel="noreferrer">
                            Ссылка на диск с договорами
                        </a>
                    </div>
                    <div className="row">
                        <InputUI
                            value={data.contractNumber}
                            onChange={(e) =>
                                setData((prev) => {
                                    return { ...prev, contractNumber: `${e.target.value}` };
                                })
                            }
                            placeholder="0000000000000"
                            label="Номер договора"
                            required
                            disabled={!disableBlock || isDisable}
                        />
                        <InputUI
                            value={data.comment}
                            onChange={(e) =>
                                setData((prev) => {
                                    return { ...prev, comment: `${e.target.value}` };
                                })
                            }
                            placeholder="Укажите понятный комметарий"
                            label="Комментарий к договору (это упростит поиск в офферах)"
                            required
                            disabled={!disableBlock || isDisable}
                        />
                    </div>

                    <div className="row">
                        <div className="wrapper">
                            <label>Дата договора*</label>
                            <Calendar
                                value={data.contractDate ? moment(data.contractDate).toDate() : ""}
                                disabled={!disableBlock || isDisable}
                                dateFormat="dd.mm.yy"
                                locale="rus"
                                onChange={(e) =>
                                    setData((prev) => {
                                        return { ...prev, contractDate: e.value };
                                    })
                                }
                                placeholder="Выберите дату"
                            />
                            <i className="pi pi-calendar"></i>
                        </div>
                        <div className="wrapper">
                            <label>Дата окончания</label>
                            <Calendar
                                value={data.expirationDate ? moment(data.expirationDate).toDate() : ""}
                                disabled={!disableBlock || isDisable}
                                dateFormat="dd.mm.yy"
                                locale="rus"
                                onChange={(e) =>
                                    setData((prev) => {
                                        return { ...prev, expirationDate: e.value };
                                    })
                                }
                                placeholder="Выберите дату"
                            />
                            <i className="pi pi-calendar"></i>
                        </div>
                    </div>

                    <div className="row">
                        <SelectSuggestUI
                            isDisabled={!disableBlock || isDisable}
                            options={select}
                            value={data.subjectType}
                            optionLabel="label"
                            optionValue="type"
                            filter={false}
                            placeholder=""
                            onChange={(e) =>
                                setData((prev) => {
                                    return { ...prev, subjectType: e.value };
                                })
                            }
                            label="Сведение о предмете договора"
                            required
                        />

                        <InputNumberUI
                            value={Number(data.price)}
                            onChange={(e) =>
                                setData((prev) => {
                                    return { ...prev, price: `${e.value}` };
                                })
                            }
                            placeholder="Укажите сумму"
                            label="Cумма договора с учетом налога"
                            disabled={!disableBlock || isDisable}
                        />
                    </div>
                </div>

                {data.ozonId ? (
                    <div className="ord__id">
                        <div className="number">
                            {"ID Договора "}
                            <span>{data.ozonId}</span>
                        </div>
                        <span className="name">от {moment(data.contractDate).format("DD.MM.YYYY")}</span>
                    </div>
                ) : null}

                {!data.ozonId ? (
                    <ButtonUI className="button__rate" label={"Отправить договор в кабинет ORD"} icon="pi pi-file" severity="success" outlined onClick={() => handleGetContract()} style={{ width: "100%" }} disabled={disableButton} />
                ) : null}
            </div>
        );
    }),
);

export default AddContract;
